import { createTheme } from "@material-ui/core/styles";
import { FontSizes, FontSizesInPixels, LetterSpacing, LineHeight } from "./fonts";
import { GoodSansRegular } from "./GoodSansRegular";
import { ErrorPalette, HomeownerPalette } from "./palettes";

const { Black, White } = HomeownerPalette;

const cssBaselineGlobals = {
  // Setting this to ignore because the @font-face isn't allowed but should be
  // @ts-ignore
  "@font-face": [GoodSansRegular],
  "*": {
    fontFamily: GoodSansRegular.fontFamily,
    fontWeight: GoodSansRegular.fontWeight,
    fontStyle: GoodSansRegular.fontStyle,
  },
  ".darkScrollbar": {
    scrollbarWidth: "6px",
    scrollbarColor: "#000 #fff",
  },
  ".darkScrollbar::-webkit-scrollbar": {
    width: "6px",
    height: "6px",
    backgroundColor: "#fff",
  },
  ".darkScrollbar::-webkit-scrollbar-track": {
    backgroundColor: "#fff",
  },
  ".darkScrollbar::-webkit-scrollbar-thumb": {
    borderRadius: "5px",
    backgroundColor: "#000000",
  },
  "h1, h2, h3, h4, h5, h6, p, hr": {
    margin: 0,
  },
  "input::-webkit-outer-spin-button, input::-webkit-inner-spin-button": {
    WebkitAppearance: "none",
    margin: 0,
  },
  "input[type=number]": {
    MozAppearance: "textfield",
  },
};

export const muiTheme = {
  themeName: "muiTheme",
  ...createTheme({
    palette: {
      primary: {
        main: Black,
        contrastText: White,
      },

      error: {
        light: ErrorPalette.LightRed,
        main: ErrorPalette.Red,
        dark: ErrorPalette.DarkRed,
        contrastText: White,
      },
      background: {
        default: White,
      },
    },
    props: {
      MuiButtonBase: {
        disableRipple: true,
      },
    },
    shape: {
      borderRadius: 25,
    },
    typography: {
      fontFamily: GoodSansRegular.fontFamily,
    },
  }),
};

muiTheme.overrides = {
  MuiCssBaseline: {
    // @ts-expect-error Material UI's JSS typing is narrower than the global selectors we use here.
    "@global": cssBaselineGlobals,
  },
  MuiMenuItem: {
    // Make select box items the right font/color.
    root: {
      ...fontStyles({ size: "F8" }),
      color: Black,
    },
  },
  MuiDrawer: {
    paperAnchorDockedLeft: {
      borderRight: 0,
    },
  },
  MuiPaper: {
    elevation8: {
      boxShadow: `0px 2px 24px ${HomeownerPalette.DarkTransparentGray}, 0px 4px 8px ${HomeownerPalette.DarkTransparentGray}`,
    },
  },
  MuiList: {
    root: {
      padding: 0,
      "&:focus": {
        outline: "none",
      },
    },
    padding: {
      paddingTop: 0,
      paddingBottom: 0,
    },
  },
  MuiDialog: {
    container: {
      cursor: "pointer",
    },
    paper: {
      cursor: "auto",
    },
  },
};

export function fontStyles(props: { size: FontSizes; lineHeight?: number; serif?: boolean }) {
  return {
    fontSize: `${FontSizesInPixels[props.size as any]}px`,
    lineHeight: `${props.lineHeight || LineHeight[props.size]}px`,
    letterSpacing: LetterSpacing[props.size],
    fontFamily: GoodSansRegular.fontFamily,
    fontWeight: GoodSansRegular.fontWeight,
  };
}
